
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

const safeParseInt = (str: string | number) => {
  const temp = str.toString();
  if (isNaN(parseInt(temp))) {
    return 0;
  } else {
    return parseInt(temp);
  }
};

@Component({})
export default class InputNumberV3 extends Vue {
  @Prop({ default: "" }) unit!: string;
  @Prop({ default: 0 }) min!: number;
  @Prop({ default: Infinity }) max!: number;
  @Prop({ default: "请输入" }) placeholder!: string;
  @Prop({ default: 1 }) step!: number;
  @Prop() value!: string | number;
  @Prop() disabled!: boolean;
  @Prop() size!: string;
  @Prop() hasFillBlock!: boolean;

  num = "";
  isMin = false;
  isMax = false;
  type = "number";
  maxLeft = 50;
  left = "";
  focusValue = "";

  @Watch("value")
  getValue(nval: number) {
    this.computedUnitPos();
    this.num = safeParseInt(nval).toString();
  }

  input(value: string) {
    if (value.includes("-")) {
      this.num = "-" + value.replace(/\D/g, "").replace(/^0([0-9])/, "$1");
    } else {
      this.num = value.replace(/\D/g, "").replace(/^0([0-9])/, "$1");
    }
    this.validMinAndMax();
  }

  computedUnitPos() {
    this.maxLeft = this.size === "large" ? 62 : 50;
    const minNumberWidth = this.getTextWidth(this.min.toString());
    const maxNumberWidth = this.getTextWidth(this.max.toString());
    // 输入框左边距12，符号距离输入框内文字4
    const maxLeft =
      Math.min(
        Math.max(minNumberWidth, maxNumberWidth) + 12 + 4,
        this.maxLeft
      ) - 42;
    this.left = maxLeft + "px";
  }

  mounted() {
    this.computedUnitPos();
    this.type = typeof this.value;
    this.num = safeParseInt(this.value).toString() || "0";
    this.validMinAndMax(true);
  }

  getFocusValue() {
    this.focusValue = this.num;
  }

  getTextWidth(str: string) {
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.visibility = "hidden";
    tempDiv.style.width = "auto";
    tempDiv.style.whiteSpace = "nowrap";
    tempDiv.innerHTML = str;
    document.body.appendChild(tempDiv);
    const textWidth = tempDiv.offsetWidth;
    document.body.removeChild(tempDiv);
    return textWidth;
  }

  checkSymbol() {
    if (this.hasFillBlock) {
      if (this.num === "-") {
        this.num = "0";
      } else if (!this.num.trim()) {
        this.num = "0";
      }
    }
    if (this.focusValue !== this.num) {
      this.$emit("input", safeParseInt(this.num));
    }
  }

  validMinAndMax(isFirst?: boolean, operate?: string) {
    if (safeParseInt(this.num) <= this.min) {
      this.num = this.min.toString();

      this.isMin = true;
    } else {
      this.isMin = false;
    }
    if (safeParseInt(this.num) >= this.max) {
      this.num = this.max.toString();
      this.isMax = true;
    } else {
      this.isMax = false;
    }
    if (isFirst) return;
    this.$emit(
      "input",
      this.type === "number" ? safeParseInt(this.num) : this.num,
      operate
    );
    this.$emit(
      "update:value",
      this.type === "number" ? safeParseInt(this.num) : this.num
    );
  }

  changeNum(step: number) {
    if ((step > 0 && this.isMax) || (step < 0 && this.isMin) || this.disabled)
      return;
    this.num = safeParseInt(this.num) + step + "";
    this.validMinAndMax(false, step > 0 ? "up" : "down");
  }
}
